import React from "react";
import { Spinner } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { fetchCustomerDetails } from "../../Services/CustomerService";
import { setItem } from "../../../Services/Storage";

export const OrderCreation = () => {
  const [customer, setCustomer] = React.useState(null);
  const [customerLoading, setCustomerLoading] = React.useState(false);
  const [showModal, setShowModal] = React.useState(null);
  const deliveryTypes = useSelector((x) => x.OrderTypes);
  const [dts, setDts] = React.useState([]);
  const [cc, setCc] = React.useState(null);
  const [bespoke, setBespoke] = React.useState([]);
  React.useEffect(() => {
    if (deliveryTypes) {
      setBespoke(
        deliveryTypes.filter((x) => x.id != 1 && x.id != 2 && x.id != 3)
      );
      setDts(deliveryTypes.filter((x) => x.id == 1 || x.id == 2));
      setCc(deliveryTypes.find((x) => x.id == 3));
    }
  }, [deliveryTypes]);

  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch({ type: "setService", payload: null });
    dispatch({ type: "setCategory", payload: null });
    dispatch({ type: "setCart", payload: [] });
    dispatch({ type: "setPickupDate", payload: null });
    dispatch({ type: "setDeliveryDate", payload: null });
    dispatch({ type: "setAddresses", payload: null });
    dispatch({ type: "setDates", payload: null });
    dispatch({ type: "setOrderType", payload: null });
    dispatch({ type: "setOrderTypeId", payload: null });
    dispatch({ type: "setBookingType", payload: null });
    dispatch({ type: "setCustomerId", payload: null });
    dispatch({ type: "setSelfPick", payload: null });
    dispatch({ type: "setProcessing", payload: null });
    dispatch({ type: "setZone", payload: null });
    const user_id = params?.["id"];
    if (user_id) {
      fetchCustomer(user_id);
    }
  }, [params, dispatch]);

  const clearNotes = () => {
  localStorage.removeItem("order_notes_saved_v1");
  };

  const fetchCustomer = (id) => {
    setCustomerLoading(true);
    clearNotes();
    fetchCustomerDetails(id).then(
      (res) => {
        setCustomer(res.data?.[0]);
        const c = res.data?.[0];
        setCustomerLoading(false);
        setItem("customer", JSON.stringify(c));
        dispatch({ type: "setCustomer", payload: c });
      },
      (err) => {
        console.warn(err);
        toast.error("Something went wrong while fetching customer details.");
      }
    );
  };

  const proceed = (e) => {
    dispatch({
      type: "setBookingType",
      payload: e.id == 1 || e.id == 2 ? e.id : 1,
    });
    dispatch({ type: "setOrderTypeId", payload: e.id });
    dispatch({
      type: "setOrderType",
      payload: e.title.toLowerCase().trim(),
    });
    dispatch({
      type: "setCustomerId",
      payload: customer.id,
    });
    dispatch({
      type: "setSelfPick",
      payload: false,
    });

    navigate(`/store/orders/add`);
  };

  const referralPercent = Number(customer?.referral_reward?.reward_amount || 0);
  const referrerFirstName = customer?.referral_reward?.consumer_f_name ;
  const referrerLastName = customer?.referral_reward?.consumer_l_name ;

  // console.log(`customer from store`,customer);  

  return (
    <>
      <div className="container py-4" style={{ minHeight: "80vh" }}>
        {customerLoading ? (
          <div className="col-12 text-center ">
            <Spinner variant="primary" />
          </div>
        ) : Boolean(customer) ? (
          <>
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title fw-bold mb-0">Create Order</h5>
                      {referralPercent > 0 && (
                        <div className="referral-blink mt-2">
                          🎉 You’ve received <strong>{referralPercent}%</strong> referral discount from{" "}
                          <strong>{referrerFirstName} {referrerLastName}</strong>{" "}
                          on your next order!
                        </div>
                      )}
                    <hr style={{ borderColor: "#282828" }} />
                    <div className="row">
                      <div className="col-md-3 col-sm-6 col-12">
                        <label className="form-label">Customer Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Example input placeholder"
                          readOnly
                          defaultValue={`${customer.f_name} ${customer.l_name}`}
                        />
                      </div>
                      <div className="col-md-3 col-sm-6 col-12">
                        <label className="form-label">Customer ID</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Example input placeholder"
                          readOnly
                          defaultValue={customer.id}
                        />
                      </div>
                      <div className="col-md-3 col-sm-6 col-12">
                        <label className="form-label">Email</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Example input placeholder"
                          readOnly
                          defaultValue={customer.email}
                        />
                      </div>
                      <div className="col-md-3 col-sm-6 col-12">
                        <label className="form-label">Phone</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Example input placeholder"
                          readOnly
                          defaultValue={customer.phone}
                        />
                      </div>
                    </div>
                    <hr style={{ borderColor: "#282828" }} />
                    <div className="row">
                      <div className="col-12">
                        <button
                          className="btn btn-dark me-2"
                          onClick={() => {
                            if (customer.addresses.length > 0) {
                              dispatch({
                                type: "setProcessing",
                                payload: "hub",
                              });
                              setShowModal(dts);
                            } else
                              toast.error(
                                "Please add addresses first to create order."
                              );
                          }}
                        >
                          Create Hub Order
                        </button>
                        <button
                          className="btn btn-dark me-2"
                          onClick={() => {
                            if (customer.addresses.length > 0) {
                              dispatch({
                                type: "setProcessing",
                                payload: "store",
                              });
                              setShowModal(dts);
                            } else
                              toast.error(
                                "Please add addresses first to create order."
                              );
                          }}
                        >
                          Create In-Store Order
                        </button>
                        {cc ? (
                          <button
                            className="btn btn-dark me-2"
                            onClick={() => {
                              dispatch({
                                type: "setOrderTypeId",
                                payload: cc.id,
                              });
                              dispatch({
                                type: "setOrderType",
                                payload: cc.title.toLowerCase().trim(),
                              });
                              dispatch({
                                type: "setCustomerId",
                                payload: customer.id,
                              });
                              navigate("/store/orders/book-an-appointment");
                            }}
                          >
                            Come & Collect
                          </button>
                        ) : null}
                        <button
                          className="btn btn-dark me-2"
                          onClick={() => {
                            if (customer.addresses.length > 0) {
                              dispatch({
                                type: "setProcessing",
                                payload: "hub",
                              });
                              setShowModal(bespoke);
                            } else
                              toast.error(
                                "Please add addresses first to create order."
                              );
                          }}
                        >
                          Bespoke Service Order
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : null}
      </div>
      <Modal
        show={Boolean(showModal)}
        backdrop="static"
        keyboard={false}
        centered
        onHide={() => {
          dispatch({ type: "setProcessing", payload: null });
          setShowModal(null);
        }}
      >
        <Modal.Header closeButton className="py-2">
          <Modal.Title style={{ fontSize: "18px" }}>
            Choose Order Type
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showModal && Array.isArray(showModal)
            ? showModal.map((e) => (
                <Card
                  key={`${e.title}-${e.id}`}
                  className="mb-3 cursor-pointer"
                  onClick={() => proceed(e)}
                >
                  <Card.Body>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <p
                        className="text-capitalize fw-semibold mb-0 cursor-pointer"
                        style={{ fontSize: "19px" }}
                      >
                        {e.title}
                      </p>
                    </div>
                    <span
                      className="hide-extra-text cursor-pointer"
                      style={{ fontSize: "16px" }}
                    >
                      {e.description}
                    </span>
                  </Card.Body>
                </Card>
              ))
            : null}
          {/* <Card className="cursor-pointer" onClick={() => proceed("express")}>
            <Card.Body>
              <div className="d-flex align-items-center justify-content-between mb-2">
                <p
                  className="text-capitalize fw-semibold mb-0"
                  style={{ fontSize: "19px" }}
                >
                  Express
                </p>
              </div>
              <span className="hide-extra-text" style={{ fontSize: "16px" }}>
                Delivery in 24 Hours
              </span>
            </Card.Body>
          </Card> */}
        </Modal.Body>
      </Modal>
    </>
  );
};
